/* eslint-env browser, jquery */
// const debug = require('debug')('auth0:enterprise');
import container from 'modules/section-content';
import metrics from 'modules/metrics';
import domify from 'domify';
import 'bootstrap';
import Batch from 'batch';
import page from 'modules/ab-page-js';
import splash from './guest-authors-page.pug';
import metadata from './metadata.json';

export default function register() {
  page('/guest-authors', render, loadScripts, snippets);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  next();
}

function loadScripts(ctx, next) {
  const batch = new Batch();

  batch.end(next);
}

function snippets(ctx, next) {
  const gallery = document.getElementById('tech-gallery');
  const fullWidth = gallery.scrollWidth;
  const viewPortWidth = window.innerWidth;

  $('.technologies-gallery').scrollLeft(fullWidth / 2 - viewPortWidth / 2);

  // Hero join us smooth scroll

  $('.join-us').on('click', e => {
    const tarHref = $(e.target).attr('href');
    const tarOffset = $(tarHref).offset().top;
    $('html, body').animate(
      {
        scrollTop: tarOffset
      },
      800
    );
  });

  $(window).scroll();

  // Form functionality

  $('.contact-form').on('submit', function(e) {
    e.preventDefault();

    const $currentForm = $(this);
    const $submitBtn = $(this).find('button[type="submit"]');
    const nameData = $currentForm.find('input[name=name]').val();
    const emailData = $currentForm.find('input[name=email]').val();
    const frameworkData = $currentForm.find('input[name=framework]').val();
    const technicalContentData = $currentForm.find('input[name=technical-content]').val();
    const articlesData = $currentForm.find('input[name=liked-articles]').val();
    const messageData = $currentForm.find('textarea[name=message]').val();

    if (!isValidEmail(emailData)) {
      alert('Please enter a valid email');
      return;
    }

    if (
      !(nameData, emailData && frameworkData && technicalContentData && articlesData && messageData)
    ) {
      alert('please fill all fields');
      return;
    }

    sendForm();

    function sendForm() {
      $submitBtn.data('orig-text', $submitBtn.text());
      $submitBtn.attr('disabled', 'disabled');
      $submitBtn.text('Sending...');

      const formDataObject = {
        name: nameData,
        email: emailData,
        framework: frameworkData,
        technical: technicalContentData,
        articles: articlesData,
        message: messageData,
        source: 'guest-authors',
        subject: `New guest author candidate - ${nameData}`
      };

      $.ajax({
        type: 'POST',
        url: 'https://wt-139739a316b9b05b2ef2d61c5ed80be7-0.sandbox.auth0-extend.com/contact-form',
        data: formDataObject,
        success() {
          $submitBtn.text('Thanks for getting in touch!');
          $submitBtn.addClass('success');

          metrics.lib().track('success:guest-author:contact', formDataObject);
        },
        error() {
          $submitBtn.text($submitBtn.data('orig-text'));
          alert('There was a problem submitting your information. Please try again later.');

          metrics.lib().track('guest-author:contact', formDataObject);
        }
      });
    }

    function isValidEmail(value) {
      const email = new RegExp(
        /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i
      );

      return email.test(value);
    }
  });

  next();
}



// WEBPACK FOOTER //
// ./src/pages/guest-authors/guest-authors.js